import * as types from '../_actions/actionTypes';
import _ from 'lodash';

const _branchList = [];

export function BranchReducer(state = { branchList: _branchList }, action) {
  switch (action.type) {
    case types.FETCH_BRANCHLIST:
      return { branchList: action.payload };
    case types.FETCH_BRANCHLIST_FAILURE:
      return { branchList: _branchList };
    default:
      return state;
  }
}
